import React from "react";

const Footer = () => {
  return (
    <div>
      <div className="section padding-top-bottom-small background-black over-hide footer">
        <div className="container">
          <div className="row">
            <div className="col-md-5 text-center text-md-left">
              <img src="/img/plogo.png" alt="Logo" />
              <p className="color-grey mt-4 text-justify">
                Hotel Pahadi Convention blends luxury and comfort with the charm
                of nature, offering a peaceful retreat in the heart of
                Rourkela’s industrial hub. Designed to deliver exceptional
                hospitality, we welcome you to experience refined stays,
                delicious dining, and warm service at one of the best hotels in
                Rourkela.
              </p>
            </div>

            <div className="col-md-2 text-center text-md-left">
              <h6 className="color-white mb-3">Quick Links</h6>
              <a href="/">Home</a>
              <a href="/about">About</a>
              <a href="/blog">Blog</a>
              <a href="/gallery">Gallery</a>
              <a href="/contact">Contact</a>
            </div>

            <div className="col-md-2 text-center text-md-left">
              <h6 className="color-white mb-3">Useful Links</h6>
              <a href="/terms">Terms &amp; Conditions</a>
              <a href="/privacypolicy">Privacy</a>
            </div>

            <div className="col-md-3 mt-4 mt-md-0 text-center text-md-left logos-footer">
              <h6 className="color-white mb-3">Contact us</h6>
              <p className="color-grey mb-4">
                <i className="fa fa-phone"></i> Hotel Pahadi, Vedvyas, Rourkela,
                Odisha, India
                <br />
                <i className="fa fa-phone"></i> +91 9238394006, +91 9692908506
                <br />
                <i className="fa fa-envelope"></i> info@hotelpahadi.com <br />
              </p>

              <h6 className="color-white mb-3">Follow Us:</h6>
              <div className="social-ftr">
                <a href="https://www.facebook.com/hotelpahadi" target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-facebook"></i>
                </a>
                <a
                  href="https://www.instagram.com/hotel_pahadi/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-instagram"></i>
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-linkedin"></i>
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-youtube"></i>
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-whatsapp"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="section py-4 background-dark over-hide footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-6 text-center text-md-left mb-2 mb-md-0">
              <p>2026 © Hotel Pahadi All rights reserved.</p>
            </div>
            <div className="col-md-6 text-center text-md-right">
              <a href="/disclaimer" className="social-footer-bottom">
                Disclaimer
              </a>
              <a href="/privacypolicy" className="social-footer-bottom">
                Privacy
              </a>
              <a href="/terms" className="social-footer-bottom">
                Terms
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Social */}
      <div className="floating-social">
        <a href="https://www.facebook.com/hotelpahadi" target="_blank" rel="noopener noreferrer" className="fb">
          <i className="fa fa-facebook"></i>
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="tw">
          <i className="fa fa-twitter"></i>
        </a>
        <a href="https://www.instagram.com/hotel_pahadi/" target="_blank" rel="noopener noreferrer" className="ig">
          <i className="fa fa-instagram"></i>
        </a>
        <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="yt">
          <i className="fa fa-youtube-play"></i>
        </a>
        <a href="https://wa.me/919000000000" target="_blank" rel="noopener noreferrer" className="wa">
          <i className="fa fa-whatsapp"></i>
        </a>
      </div>

      {/* Scroll to Top */}
      <div className="scroll-to-top"></div>
    </div>
  );
};

export default Footer;
